module.exports = __webpack_public_path__ + "static/media/LC.ae3fd80b.svg";